import type { ComponentType } from "@repo/editor/types";
import type { ReactNode } from "react";
import { forwardRef } from "react";
import * as t from "@rekajs/types";
import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";

export const WhatWeDoDefinition: ComponentSettingsProps = {
  title: {
    label: "عنوان",
    section: "محتوا",
    type: "string",
    default: "عنوان",
  },
  description: {
    label: "توضیحات",
    section: "محتوا",
    type: "string",
    default: "html",
  },
  sectionNumber: {
    label: "شماره بخش",
    section: "محتوا",
    type: "string",
  },
  leftContent: {
    label: "محتوای سمت چپ",
    section: "محتوا",
    type: "html",
  },
  rightContent: {
    label: "محتوای سمت راست",
    section: "محتوا",
    type: "html",
  },
};
export interface WhatWeDoProps {
  title: string;
  description: string;
  sectionNumber: string;
  leftContent: string;
  rightContent: string;
  children: ReactNode;
}

export const WhatWeDo = forwardRef<HTMLDivElement, WhatWeDoProps>(
  (props, ref) => {
    return (
      <div className="bg-[#4C4C4C] w-full h-full relative ql-editor" ref={ref}>
        <img
          alt="map"
          className="absolute top-0 right-0 w-2/3 h-full object-contain"
          onError={(e) => {
            e.currentTarget.src = "/images/placeholder.png";
          }}
          src="/images/map.png"
        />
        <div className="container relative z-10 mx-auto flex gap-4 lg:py-20 py-10">
          <div className="lg:flex hidden gap-4 w-2/5 pt-48">
            <div
              className="font-inter rtl:font-doran text-[22.39px] rtl:text-[27px] text-white"
              dangerouslySetInnerHTML={{ __html: props.leftContent }}
            />
          </div>
          <div className="flex flex-col gap-2 lg:w-3/5 w-full">
            <div className="relative">
              <div className="box-content text-[130px] leading-[1.07] lg:leading-[336px] md:text-[200px] lg:text-[314.28px] -tracking-[6.55px] font-[100] lg:font-[250] lg:-tracking-[0.05em] font-helvetica rtl:font-dirooz text-[#FF770033]">
                {props.sectionNumber}
              </div>
              <div className="absolute top-1/2 translate-y-[-50%]">
                <div className="text-[35px] rtl:text-[40px] md:text-[50px] lg:text-[83.95px] font-helvetica rtl:font-doran font-[100] rtl:font-medium lg:font-250 rtl:lg:font-bold text-white uppercase">
                  {props.title}
                </div>
                <div className="text-[12.8px] rtl:text-[15px] md:text-[20px] lg:text-[30.65px] font-helvetica rtl:font-doran font-300 text-white uppercase">
                  {props.description}
                </div>
              </div>
            </div>
            <div
              className="font-inter rtl:font-doran text-[8px] rtl:text-[12px] md:text-[14px] lg:text-[16.79px]  text-white border-[#FF7700] border-b pb-6"
              dangerouslySetInnerHTML={{ __html: props.rightContent }}
            />
            {props.children}
          </div>
        </div>
      </div>
    );
  }
) as ComponentType<WhatWeDoProps>;
WhatWeDo.displayName = "WhatWeDo";

export const WhatWeDoSettings: ComponentSettings = {
  name: "EWhatWeDo",
  props: WhatWeDoDefinition,
  label: "بخش ما در باره ما",
  childrenAllowed: ["EWhatWeDoItem"],
  widgets: {
    label: "بخش ما در باره ما",
    template: () => {
      return t.componentTemplate({
        component: t.identifier({
          name: "EWhatWeDo",
          external: true,
        }),
        props: {
          leftContent: t.literal({
            value:
              "<p dir='ltr'><span style='white-space: pre-wrap;'>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is available.</span></p>",
          }),
          rightContent: t.literal({
            value:
              "<p dir='ltr'><span style='white-space: pre-wrap;'>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is available.</span></p>",
          }),
          title: t.literal({ value: "what we do" }),
          description: t.literal({ value: "Superpower of Power Electrics" }),
          sectionNumber: t.literal({ value: "03" }),
        },
        children: [
          t.componentTemplate({
            component: t.identifier({
              name: "EWhatWeDoItem",
              external: true,
            }),
            props: {
              title: t.literal({ value: "17" }),
              description: t.literal({ value: "years in business" }),
            },
          }),
          t.componentTemplate({
            component: t.identifier({
              name: "EWhatWeDoItem",
              external: true,
            }),
            props: {
              title: t.literal({ value: "124" }),
              description: t.literal({ value: "projects" }),
            },
          }),
          t.componentTemplate({
            component: t.identifier({
              name: "EWhatWeDoItem",
              external: true,
            }),
            props: {
              title: t.literal({ value: "$160" }),
              description: t.literal({ value: "total equity" }),
            },
          }),
        ],
      });
    },
  },
};

WhatWeDo.componentSettings = WhatWeDoSettings;
